import {findAll} from "../../../../modules/vegas/js/util";
import {VGFormSender} from "vgformsender";
import {onReady} from "../../../../modules/vegas/js/util";

function hideBSModal() {
	let bsModalShow = document.querySelector('.modal.show');
	if (bsModalShow) {
		let bsModal = bootstrap.Modal.getInstance(bsModalShow);
		bsModal.hide();
	}
}

function init() {
	[...findAll('[data-vgformsender]')].map((form) => {
		new VGFormSender(form, {
			alert: {
				delay: 100
			}
		}).submit({
			success: () => {
				hideBSModal();
			},
			error: () => {
				hideBSModal();
			}
		});
	});
}

onReady(init);
typeof onTurboRender !== 'undefined' && onTurboRender(init);
